import { render, staticRenderFns } from "./splitInvoice.vue?vue&type=template&id=6cc1464d&scoped=true&"
import script from "./splitInvoice.vue?vue&type=script&lang=js&"
export * from "./splitInvoice.vue?vue&type=script&lang=js&"
import style0 from "./splitInvoice.vue?vue&type=style&index=0&id=6cc1464d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc1464d",
  null
  
)

export default component.exports